import React from 'react';
import './ContactComponents.css';
import { urlFor } from '../../../sanity/client';

const DojangInfo = ({ data }) => {
    return (
        <div className="dojang-info-box">
            <div className="instructor-img" 
            style={{backgroundImage: data.image
            ? `url(${urlFor(data.image).width(400).url()})`
            : "none"}}></div>
            <div className="info-details">
                <h3>Instructor: {data.instructor}</h3>
                <p className="info-text">Dirección: {data.address}</p>
                <p className="info-text">Teléfono: {data.phone}</p>
            </div>
        </div>
    );
};

export default DojangInfo;
